import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddButton from '../../core/AddButton';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import CreateConceptDialog from './CreateConceptDialog';

class CreateTopConceptDialogContainer extends Component {

  render() {

    const { onAddNewConcept, schemeIRI, onAddExistingConcept, graph, useSlashIRI, useUuidIRI,
       button, disableMultiple, useXL, defaultClasses, iriOptions, useWorkflow } = this.props;

    return (
      <ProjectConsumer>
        {({ id: projectIRI, skosXL, defaultLang }) => (
          <CreateConceptDialog
            button={button || <AddButton title="Add a top concept" />}
            optionForXL={skosXL}
            useXL={useXL}
            useWorkflow={useWorkflow}
            defaultClasses={defaultClasses}
            graph={graph}
            iriOptions={iriOptions}
            isTopConcept={true}
            defaultLang={defaultLang}
            schemeIRI={schemeIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}   
            disableMultiple={disableMultiple}
            parentIRI={schemeIRI}
            projectIRI={projectIRI}
            property='hasTopConcept'
            onAddExistingConcept={onAddExistingConcept}
            onAddNewConcept={onAddNewConcept}
            placeholder="Enter concept label"
            title="Add Top Concept" />
        )}
      </ProjectConsumer>
    );
  }

}

CreateTopConceptDialogContainer.propTypes = {
  button: PropTypes.object,
  graph: PropTypes.string.isRequired,
  useXL: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  defaultClasses: PropTypes.array,
  disableMultiple: PropTypes.bool,
  schemeIRI: PropTypes.string.isRequired,
  onAddExistingConcept: PropTypes.func.isRequired,
  onAddNewConcept: PropTypes.func.isRequired,
  iriOptions: PropTypes.object
};

export default CreateTopConceptDialogContainer;